import { useDropZone } from '@jotta/hooks'
import { observer } from 'mobx-react-lite'
import { useCallback, useState } from 'react'
import { fileUploadManager } from '../ActionManager/FileUploadManager'
import { FileUploadErrorDialog } from '../FileUploadErrorDialog/FileUploadErrorDialog'
import { FileUploadStatus } from '../FileUploadStatus/FileUploadStatus'
import { FolderFab } from '../Folder/FolderFab'
import type { FolderStore } from '../Folder/FolderStore'
import { UploadOverlay } from '../UploadOverlay/UploadOverlay'
import { FileReadErrorDialog } from './FileReadErrorDialog'

export const FileUpload = observer<{ folder: FolderStore }>(
  function FileUpload({ folder }) {
    const [errorPaths, setErrorPaths] = useState<string[]>([])
    const onCloseErrorDialog = useCallback((open: boolean) => {
      if (!open) {
        setErrorPaths([])
      }
    }, [])
    const canUpload = folder.pathItem.canUpload
    const isDragging = useDropZone({
      onAcceptFiles: canUpload ? folder.actions.upload : undefined,
      allowFolderUploads: true,
      onError: setErrorPaths,
    })

    return (
      <>
        <UploadOverlay
          open={isDragging}
          uploadsAllowed={folder.pathItem.canUpload}
        />
        {canUpload && <FolderFab store={folder} />}
        {canUpload && <FileUploadStatus manager={fileUploadManager} />}
        {canUpload && <FileUploadErrorDialog manager={fileUploadManager} />}
        {canUpload && (
          <FileReadErrorDialog
            paths={errorPaths}
            onClose={onCloseErrorDialog}
          />
        )}
      </>
    )
  },
)
